import { useRef } from 'react'
import { FiSave, FiX } from 'react-icons/fi'

import { FormHandles } from '@unform/core'
import i from 'i18next'

import { Button } from '~/components/Buttons'
import { FormGroup } from '~/components/unform'
import Form from '~/components/unform/Form'

import FormContext from '../FormContext'
import FormFormats from '../FormFormats'
import FormMainInfo from '../FormMainInfo'

const PlacementForm: React.FC<PlacementFormProps> = ({
  onSubmit,
  isLoading,
  initialData,
  fieldsets = null,
  onCancel = null
}) => {
  const formRef = useRef<FormHandles>(null)

  return (
    <Form
      ref={formRef}
      className="form-grid"
      onSubmit={onSubmit}
      initialData={initialData}
    >
      {/* Informações gerais */}
      {(!fieldsets || fieldsets.includes('main')) && (
        <FormMainInfo formRef={formRef} />
      )}
      {/* Contexto da campanha */}
      {(!fieldsets || fieldsets.includes('context')) && <FormContext />}
      {/* Formato do anúncio */}
      {(!fieldsets || fieldsets.includes('formats')) && (
        <FormFormats initialData={initialData} />
      )}

      <FormGroup className="actionButtons">
        {!!onCancel && (
          <Button
            text={i.t('common:actions.cancel')}
            iconLeft={<FiX />}
            onClick={onCancel}
            loading={isLoading}
            template="transparentCritical"
            className="me-auto px-0"
          />
        )}

        <Button
          text={i.t('common:actions.save')}
          textLoading={`${i.t('common:actions.saving')}...`}
          iconLeft={<FiSave />}
          loading={isLoading}
          template="primary"
          type="submit"
        />
      </FormGroup>
    </Form>
  )
}

export default PlacementForm
